/**
 * Display formatters that cap decimal places but omit insignificant trailing zeros.
 * e.g. 110 → "110", 110.5 → "110.5", 1000.25 → "1,000.25" (not "1,000.2500").
 */

export function formatDecimalNatural(num: number, maxFractionDigits: number, locale = 'en-US'): string {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: maxFractionDigits,
  }).format(num);
}

export function formatDecimalFixed(num: number, fractionDigits: number, locale = 'en-US'): string {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(num);
}

export function formatPercentageNatural(num: number, maxFractionDigits: number): string {
  if (maxFractionDigits <= 0) return `${Math.round(num)}%`;
  const trimmed = num.toFixed(maxFractionDigits).replace(/\.?0+$/, '');
  return `${trimmed}%`;
}

export function formatPercentageFixed(num: number, fractionDigits: number): string {
  return `${num.toFixed(fractionDigits)}%`;
}
